
export function changeYearRow(yearRowIndex){
	return {
		type: "CHANGE_YEAR_ROW",
		yearRowIndex
	};
}
